import React, { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { blockMenuMessages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import AngleBracketsIcon from '@atlaskit/icon/core/angle-brackets';
var nodeName = 'codeBlock';
var CodeBlockMenuItem = function CodeBlockMenuItem(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var selection = useSharedPluginStateSelector(api, 'selection.selection');
  var isCodeBlockSelected = useMemo(function () {
    if (!selection) {
      return false;
    }
    if (selection instanceof NodeSelection) {
      // Note: we are checking for any type of panel, not just of type infopanel
      return selection.node.type.name === nodeName;
    }
    return false;
  }, [selection]);
  var handleClick = function handleClick() {
    var _api$blockMenu;
    api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.formatNode(nodeName));
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    onClick: handleClick,
    isSelected: isCodeBlockSelected,
    elemBefore: /*#__PURE__*/React.createElement(AngleBracketsIcon, {
      label: ""
    })
  }, formatMessage(blockMenuMessages.codeBlock));
};
export var createCodeBlockMenuItem = function createCodeBlockMenuItem(api) {
  return function () {
    return /*#__PURE__*/React.createElement(CodeBlockMenuItem, {
      api: api
    });
  };
};